import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
import createCustomSaveVuexModule from "@/store/customSaveStore";
const path = "/organization";

export const organization = createCrudVuexModule({
  path: path,
  namespaced: true,
  persistent: ["selectedOrganizationPermissions", "selected"],

  state: { dashboard: null, selected: null, editedOrganization: null, selectedOrganizationPermissions: [], isDownloading: false },
  getters: {
    isDownloading: (state) => state.isDownloading,
    selected: (state) => state.selected,
    selectedOrganizationPermissions: (state) => state.selectedOrganizationPermissions,
    editedOrganization: (state) => state.editedOrganization,
    isEditMode: (state) => !!state.editedOrganization?._id,
    dashboard: (state) => state.dashboard,
  },
  mutations: {
    isDownloading: (state, value) => (state.isDownloading = value),
    selected: (state, value) => {
      state.selected = {
        ...value,
        roles: value.roles?.map((r) => ({ _id: r._id, name: r.name, permissions: r.permissions?.map((rp) => ({ definition: rp.definition, name: rp.name })) })),
        workspace: {
          _id: value.workspace?._id,
          name: value.workspace?.name,
        },
      };

      //Flat Permissions
      if (value.roles) {
        const permissions = new Set();
        for (const role of value.roles) {
          for (const permission of role.permissions) {
            permissions.add(permission.definition);
          }
        }
        state.selectedOrganizationPermissions = [...permissions];
      }
    },
    reset: (state) => {
      state.selected = null;
      state.editedOrganization = null;
      state.selectedOrganizationPermissions = [];
    },
    editedOrganization: (state, value) => (state.editedOrganization = value),
    dashboard: (state, value) => (state.dashboard = value),
  },
  actions: {
    async save({ dispatch }, payload) {
      if (payload.organization._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },

    async paginate({ state, commit }, pagination) {
      commit("isLoading", true);
      try {
        commit("pagination", undefined);
        const response = await rest.post(`${path}/paginate`, { pagination });
        commit("pagination", response.data);
        /*    if (!state.selected && state.pagination.docs && state.pagination.docs.length > 0) {
          commit("selected", response.data.docs[0]);
        } */

        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async dashboard({ state, commit }) {
      commit("isLoading", true);
      try {
        commit("dashboard", undefined);
        const response = await rest.get(`${path}/dashboard`);
        commit("dashboard", response.data);

        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    selected({ commit }, organization) {
      commit("selected", organization);
    },

    async invite({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/organization/invite`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationMember = createCustomSaveVuexModule({
  path: "/organization/member",
  namespaced: true,

  state: {
    isDownloading: false,
  },
  getters: {
    isDownloading: (state) => state.isDownloading,
    accesableOrganizationMembers: (state) => state.pagination?.docs.filter((member) => member.accessable) ?? [],
  },

  mutations: {
    isDownloading: (state, value) => (state.isDownloading = value),
  },
  actions: {
    async paginateWithForSearch({ commit }, payload = {}, clearStateBeforeRest = false) {
      commit("isSearchLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("paginationForSearch", undefined);
        }
        const response = await rest.post(`organization/member/paginate`, { ...payload });

        commit("paginationForSearch", response.data);
        return response;
      } finally {
        commit("isSearchLoading", false);
      }
    },
    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post(`/organization/member/download`, payload);

        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
    async delete({ dispatch }, payload) {
      try {
        await rest.post("/organization/member/delete", payload);
      } finally {
      }
    },
  },
});
